import { Alert } from 'antd';

export default function PurcheseAlertBoshMigration() {
  return (
    <Alert
      type="warning"
      style={{ marginBottom: 24 }}
      description={
        <>
          <p>
            Esta compra foi identificada como proveniente da{' '}
            <strong>BOSCH</strong>. Por esse motivo, esta compra está restrita
            exclusivamente à leitura. Você apenas poderá visualizar os detalhes
            contidos nesta compra. Esta medida visa garantir a integridade dos
            dados importados da <strong>BOSCH</strong>.
          </p>

          <span>
            Caso queira gerar uma nota de devolução, será necessário fazê-lo
            manualmente.
          </span>
        </>
      }
    />
  );
}
